<template>
    <div>
        <div class="popup__header" style="border-bottom: 1px solid #E9E9E9;">
            <span class="title title--sm popup__title">{{ $lang('registration.title') }}</span>
            <span class="popup__header-description" v-html="$lang('registration.description')"></span>
        </div>
        <div class="popup__content">
            <errors :errors="errors"></errors>
            <form class="form" @submit.prevent="registerPost">
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('registration.label.name') }}</span>
                        <el-input class="input input--big" :placeholder="$lang('registration.label.name.placeholder')" v-model="formAuth.name" required dusk="auth-name"></el-input>
                    </label>
                </div>
                <div class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('registration.label.email') }}</span>
                        <el-input class="input input--big" :placeholder="$lang('email.input.placeholder')" v-model="formAuth.email" dusk="auth-email"></el-input>
                    </label>
                </div>
                <div v-if="locale === 'ru'" class="form__item form__item--inline">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('registration.label.phone') }}</span>
                        <input-phone v-model="formAuth.phone" class="input input--big" dusk="auth-phone"/>
                    </label>
                </div>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg" dusk="auth-registration">{{ $lang('registration.button.reg') }}</button>
                </div>
                <div class="form__item">
                    <el-checkbox v-model="formAuth.checked" required dusk="auth-checkbox"
                        >{{ $lang('registration.policy.part1') }}  <a class="el-checkbox__link" target="_blank" href="/assets/front/pdf/memorycode_processing_of_personal_data.pdf">{{ $lang('registration.policy.part2') }}</a>
                    </el-checkbox>
                </div>
                <div class="form__item form__item--inline">
                    <span class="popup__auth-hint">{{ $lang('registration.hint') }}</span>
                    <router-link class="link" :to="{name: 'login', query: $route.query}">
                        <span>{{ $lang('registration.button.login') }}</span>
                    </router-link>
                </div>
            </form>
        </div>
        <el-dialog class="popup popup--success"
                   :width="windowWidth > 992 ? '770px' : '75%'"
                   top="50vh"
                   :append-to-body="true"
                   :show-close="false"
                   :visible="!!showMessage">
            <span class="popup__success">{{ showMessage }}</span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
    import Errors from "../error/errors";
    import InputPhone from "../../components/InputPhone";
    import width from "../../mixins/width";

    export default {
        name: "Registration",
        mixins: [width],
        components: {Errors, InputPhone},
        data: () => ({
            errors: null,
            showMessage: null,
            locale: window.laravel.locale
        }),
        computed: {
            ...mapState('auth',[
                'formAuth',
            ]),
            ...mapGetters('auth', [
                'isAuth',
            ]),
        },
        mounted() {
            if (!this.isAuth) {
                return;
            }

            const params = (new URL(window.location)).searchParams;

            if (Object.is(NaN, parseInt(params.get('client_id'))) || !params.get('redirect_url')) {
                return;
            }

            this.formAuth.client_id = parseInt(params.get('client_id'));
            this.formAuth.redirect_url = params.get('redirect_url');

            if (params.get('relation')) {
                this.formAuth.relation = params.get('relation');
            }

            this.$loading(this.$optionsLoading);

            this.login()
                .then((response) => {
                    if (Object(response.data).hasOwnProperty('redirect')) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch((error) => {
                    this.errors = error.response?.data?.errors;
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        methods: {
            ...mapActions('auth', [
                'register',
                'login',
            ]),
            ...mapMutations('auth', [
                'clearData',
                'generatePassword',
            ]),
            registerPost() {
                const params = (new URL(window.location)).searchParams;
                this.generatePassword();
                this.formAuth.sendPassword = true;
                this.errors = null;

                if (!!params.get('redirect')) {
                    this.formAuth.redirect = params.get('redirect');
                }

                if (!Object.is(NaN, parseInt(params.get('client_id')))) {
                    if (params.get('redirect_url')) {
                        this.formAuth.client_id = parseInt(params.get('client_id'));
                        this.formAuth.redirect_url = params.get('redirect_url');

                        if (params.get('relation')) {
                            this.formAuth.relation = params.get('relation');
                        }
                    }
                }

                this.$loading(this.$optionsLoading);

                this.register().then((response) => {
                    this.$dataLayer.push({'event': 'createUser', 'user_id': response.data.user.id});

                    if (response.data.user.hasOwnProperty('show_message')) {
                        this.$appNotify.success(response.data.user.show_message);

                        setTimeout(() => {
                            window.location.href = response.data.redirect
                        }, 3000);
                    } else {
                        console.log(response.data.redirect);
                        
                        window.location.href = response.data.redirect;
                    }
                }).catch((error) => {
                    let data = error.response.data;

                    if (data.hasOwnProperty('errors')) {
                        this.errors = data.errors;
                    } else if (data.message) {
                        this.$appNotify.error(data.message);
                    }
                }).finally(() => {
                    this.$loading({}).close();
                });
            }
        },
        beforeDestroy() {
            this.$nextTick(() => {
                this.clearData();
            });
        },
    }
</script>

